namespace $.$$ {
	
	$mol_style_define( $yuf_check_icon2, {
		'@': {
			mol_check_checked: {
				true: {
					color: 'inherit',
				}
			}
		},
		
		
	} )
	
}
